import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectSource } from 'shared/selectors';
import { getJsonQuery } from 'shared/selectors/getJsonQuery';

import { trackMortgageBrokerBannerClick, trackMortgageBrokerBannerShow } from './tracking';
import { configSelector } from '../../../selectors/configSelector';
import { MortgageBrokerBanner } from '../../components/MortgageBrokerBanner';

/**
 * Баннер "Циан.Ипотека для профи"
 */
export const MortgageBrokerBannerContainer = () => {
  const config = useSelector(configSelector);
  const url = config.get<string>('mortgage-broker-application-frontend.promoUrl') || '';
  const jsonQuery = useSelector(getJsonQuery);
  const source = useSelector(selectSource);

  const handleClick = React.useCallback(() => {
    trackMortgageBrokerBannerClick(jsonQuery, source);
  }, [jsonQuery, source]);

  const handleShow = React.useCallback(() => {
    trackMortgageBrokerBannerShow(jsonQuery, source);
  }, [jsonQuery, source]);

  return (
    <ActionAfterViewObserver callback={handleShow} percentVisible={0.8} triggerOnce>
      <MortgageBrokerBanner url={url} onClick={handleClick} />
    </ActionAfterViewObserver>
  );
};

MortgageBrokerBannerContainer.displayName = 'MortgageBrokerBannerContainer';
